import { render } from "./HideableItems.vue?vue&type=template&id=c8f75116&scoped=true"
import script from "./HideableItems.vue?vue&type=script&lang=js"
export * from "./HideableItems.vue?vue&type=script&lang=js"

import "./HideableItems.vue?vue&type=style&index=0&id=c8f75116&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-c8f75116"

export default script